import { RouterProvider } from 'react-router-dom';
import { QueryProvider } from '@/providers/QueryProvider';
import { ThemeProvider } from '@/providers/ThemeProvider';
import { ToastProvider } from '@/providers/ToastProvider';
import { DemoBanner } from '@/components/layout/DemoBanner';
import { router } from '@/router';

export default function App() {
  return (
    <QueryProvider>
      <ThemeProvider>
        <RouterProvider router={router} />
        <ToastProvider />
        <DemoBanner />
      </ThemeProvider>
    </QueryProvider>
  );
}
